import React from "react";
import styled, { css } from "styled-components";

import Text from "components/ui/Text";

const TERMS_TEXT = [
  {
    title: "1. 수집 및 이용 목적",
    contents: [
      {
        num: "0",
        text: `고객에 대한 편의 제공, 제휴 가맹점의 상품, 서비스 안내 및 이용권유, 사은/판촉행사  등의 마케팅 활동, 시장 조사 및 상품/서비스 개발 연구등을 목적으로 수집 및 이용`,
      },
    ],
  },
  {
    title: "2. 수집 및 이용 항목",
    contents: [
      {
        num: "0",
        text: `개인 식별 정보 : 성명, 나이, 휴대전화번호, 이메일 등`,
      },
      {
        num: "0",
        text: `기타 : 아이디, 접속일시, 접속 IP주소 등`,
      },
    ],
  },
  {
    title: "3. 보유기간",
    contents: [
      {
        num: "0",
        text: `동의일로부터 회원 탈퇴 혹은 마케팅 동의 해제시까지 보유/이용`,
      },
    ],
  },
];

const TermsMarketing = ({ header = true, type, onClose }) => {
  return (
    <Wrapper>
      {header && (
        <Header>
          <Text fontSize="18px" lineHeight="24px">
            마케팅 활용 및 광고성 정보 수신 동의
          </Text>
          <Text lineHeight="24px" onClick={onClose}>
            닫기
          </Text>
        </Header>
      )}
      <Main>
        <Text color="gray80" fontSize="14px" lineHeight="24px">
          이용자는 개인(신용) 정보의 선택적인 수집 이용, 제공에 대한 동의를
          거부할 수 있습니다. 다만, 동의하지 않을 경우, 관련 편의 제공(이벤트
          안내, 공지사항, 할인행사) 안내 등 이용목적에 따른 혜택에 제한이 있을
          수 있습니다.
        </Text>
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="24px"
          css={css`
            margin-bottom: 16px;
          `}
        >
          그 밖에 계약과 관련된 불이익은 없습니다. 동의한 경우에도 이용자는 앱내
          설정 메뉴에서, 동의를 철회하거나 마케팅 목적으로 연락하는 것을
          중지하도록 요청할 수 있습니다.
        </Text>

        {TERMS_TEXT.map((v) => {
          return (
            <TextWrapper key={v.title}>
              <Text
                color="gray80"
                fontSize="16px"
                fontWeight="700"
                lineHeight="24px"
                css={css`
                  margin-bottom: 8px;
                `}
              >
                {v.title}
              </Text>
              {v.contents.map((c, i) => {
                return (
                  <TextBox key={i}>
                    {c.num !== "0" && (
                      <Text color="gray80" fontSize="14px" lineHeight="24px">
                        {c.num}.
                      </Text>
                    )}
                    <Text color="gray80" fontSize="14px" lineHeight="24px">
                      {c.text}
                    </Text>
                  </TextBox>
                );
              })}
            </TextWrapper>
          );
        })}
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="24px"
          css={css`
            margin-bottom: 16px;
          `}
        >
          더 자세한 사항은 개인정보처리방침을 참고하시기 바랍니다.
        </Text>
      </Main>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100% !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 0 24px 56px !important;
  overflow-y: auto;
`;

const Header = styled.div`
  padding: 14px 0;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  span:last-of-type {
    position: absolute;
    right: 0;
  }
`;

const Main = styled.div``;
const TextWrapper = styled.div`
  margin-bottom: 16px;
`;

const TextBox = styled.div`
  display: flex;
  span:first-child {
    margin-right: 4px;
  }
  span:last-child {
    white-space: pre-line;
  }
`;
export default TermsMarketing;
